// extracted by mini-css-extract-plugin
export default {"wrapper":"text-area_wrapper__KSSnU","label":"text-area_label__CsFRb"};